<div class="p-container">
  <div class="max-w-4xl mx-auto p-4 md:p-6 space-y-6">
    <div class="mb-6 flex items-center gap-3">
      <div
        class="w-12 h-12 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center shadow-sm border border-blue-100"
      >
        <i class="pi pi-list text-2xl"></i>
      </div>
      <div>
        <h2 class="text-2xl font-bold text-foreground">Assessment Details</h2>
        <p class="text-sm text-muted-color mt-1">
          Review the answers provided during the pre-assessment.
        </p>
      </div>
    </div>

    <div
      *ngIf="QuestionNAnswerList.length === 0"
      class="text-center p-12 bg-gray-50 rounded-3xl border border-gray-100 shadow-sm flex flex-col items-center justify-center"
    >
      <div class="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-sm mb-4">
        <i class="pi pi-inbox text-4xl text-gray-300"></i>
      </div>
      <p class="text-gray-600 font-bold text-lg">No Answers Found</p>
      <p class="text-gray-400 text-sm mt-1 max-w-sm">
        No pre-assessment answers are available for this appointment history.
      </p>
    </div>

    <div class="space-y-6">
      <div
        *ngFor="let qa of QuestionNAnswerList; let i = index"
        class="bg-card p-6 rounded-3xl shadow-sm border border-gray-100 animate-fade-in relative overflow-hidden group hover:shadow-md transition-shadow"
      >
        <!-- Decorator Line -->
        <div
          class="absolute left-0 top-0 bottom-0 w-[5px] bg-orange-500 opacity-20 group-hover:opacity-100 transition-opacity"
        ></div>

        <div class="flex items-start gap-5 pl-2 relative z-10">
          <!-- Question Numbering -->
          <div
            class="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-orange-50 to-orange-100 text-orange-700 rounded-full flex justify-center items-center font-bold text-md shadow-inner border border-orange-200"
          >
            {{ i + 1 }}
          </div>

          <div class="flex-1 min-w-0 pt-1">
            <!-- Question Details -->
            <div class="mb-5 flex justify-between items-start">
              <!-- Left: Question -->
              <h3 class="text-[17px] font-bold text-foreground leading-snug">
                {{ qa.question }}
              </h3>

              <!-- Right: Type -->
              <span
                class="inline-flex items-center gap-1.5 text-[11px] font-extrabold text-gray-600 bg-orange-50 px-3 py-1.5 rounded-lg border border-gray-200 shadow-sm uppercase tracking-wider"
              >
                <i class="pi pi-tag text-[10px]"></i>
                {{ getQuestionTypeText(qa.question_type) }}
              </span>
            </div>

            <!-- Answer Section based on Type -->
            <div [ngSwitch]="qa.question_type">
              <!-- Type 1: Single Choice & Type 2: Multi Choice -->
              <div *ngSwitchCase="QuestionType.Single_Choice" class="flex flex-wrap gap-2.5 mt-2">
                <span
                  *ngFor="let val of splitValues(qa.question_values)"
                  class="px-5 py-2.5 rounded-2xl bg-gradient-to-r from-blue-50 to-blue-50/50 text-blue-800 border-2 border-blue-200 font-bold text-sm shadow-sm flex items-center gap-2 transition-all hover:-translate-y-0.5 hover:shadow-md"
                >
                  <i class="pi pi-check-circle text-blue-500 text-lg"></i>
                  {{ val }}
                </span>
              </div>

              <div *ngSwitchCase="QuestionType.Multi_Choice" class="flex flex-wrap gap-2.5 mt-2">
                <span
                  *ngFor="let val of splitValues(qa.question_values)"
                  class="px-4 py-2 rounded-xl bg-gray-50 text-gray-800 border-2 border-gray-200 font-semibold text-sm flex items-center gap-2 shadow-sm transition-all hover:border-gray-300"
                >
                  {{ val }}
                </span>
              </div>

              <!-- Type 4: Yes/No -->
              <div *ngSwitchCase="QuestionType.Yes_No" class="mt-2 text-sm font-bold">
                <span
                  *ngIf="qa.question_values?.toLowerCase() === 'yes'"
                  class="inline-flex items-center gap-2.5 px-6 py-2.5 rounded-full bg-green-50 text-green-700 border-2 border-green-200 shadow-sm hover:shadow-md transition-shadow"
                >
                  <i class="pi pi-check-circle text-lg"></i> YES
                </span>
                <span
                  *ngIf="qa.question_values?.toLowerCase() === 'no'"
                  class="inline-flex items-center gap-2.5 px-6 py-2.5 rounded-full bg-red-50 text-red-700 border-2 border-red-200 shadow-sm hover:shadow-md transition-shadow"
                >
                  <i class="pi pi-times-circle text-lg"></i> NO
                </span>
                <!-- Fallback if it's stored differently -->
                <span
                  *ngIf="
                    qa.question_values?.toLowerCase() !== 'yes' &&
                    qa.question_values?.toLowerCase() !== 'no' &&
                    qa.question_values
                  "
                  class="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gray-100 text-gray-700 border border-gray-200 shadow-sm"
                >
                  {{ qa.question_values }}
                </span>
              </div>

              <!-- Type 5: File Upload & Type 10/12 (via report_url or plain string) -->
              <div
                *ngIf="
                  qa.question_type === QuestionType.File_Upload ||
                  qa.report_url ||
                  isImageUrl(qa.question_values)
                "
                class="mt-4"
              >
                <div
                  *ngIf="isImageUrl(qa.report_url || qa.question_values)"
                  class="flex flex-col gap-4"
                >
                 
                  <div>
                    <i class="pi pi-upload max-h-72 rounded-2xl border-2 border-gray-100 shadow-sm object-contain bg-gray-50 p-2"> Uploaded Report</i>
                  </div>
                  <div class="flex items-center gap-3">
                    <a
                      [href]="qa.report_url || qa.question_values"
                      target="_blank"
                      class="no-underline"
                    >
                      <p-button
                        icon="pi pi-external-link"
                        label="Open in New Tab"
                        size="small"
                        severity="secondary"
                      ></p-button>
                    </a>
                    <a [href]="qa.report_url || qa.question_values" download class="no-underline">
                      <p-button icon="pi pi-download" label="Download" size="small"></p-button>
                    </a>
                  </div>
                </div>

                <div
                  *ngIf="
                    !isImageUrl(qa.report_url || qa.question_values) &&
                    (qa.report_url ||
                      qa.question_values?.startsWith('http') ||
                      qa.question_values?.startsWith('www'))
                  "
                  class="flex flex-col gap-3"
                >
                  <div
                    class="py-4 px-5 rounded-2xl border-2 border-gray-100 bg-gray-50 flex items-center gap-4 w-full sm:w-auto min-w-[280px]"
                  >
                    <div
                      class="w-12 h-12 rounded-xl bg-white border border-gray-200 flex items-center justify-center text-blue-500 shadow-sm"
                    >
                      <i class="pi pi-file-pdf text-xl"></i>
                    </div>
                    <div class="flex flex-col flex-1">
                      <span class="text-sm font-bold text-gray-800">Attached File / Link</span>
                      <span class="text-xs font-semibold text-gray-400 mt-0.5"
                        >Click actions to view</span
                      >
                    </div>
                  </div>
                  <div class="flex items-center gap-3 mt-1">
                    <a
                      [href]="qa.report_url || qa.question_values"
                      target="_blank"
                      class="no-underline"
                    >
                      <p-button
                        icon="pi pi-file"
                        label="View Document"
                        size="small"
                        severity="secondary"
                      ></p-button>
                    </a>
                    <a [href]="qa.report_url || qa.question_values" download class="no-underline">
                      <p-button icon="pi pi-download" label="Download File" size="small"></p-button>
                    </a>
                  </div>
                </div>
              </div>

              <!-- Type 9: Dietary Recall -->
              <div *ngSwitchCase="QuestionType.Dietry_Recall" class="mt-4">
                <div
                  *ngIf="!qa.question_values || qa.question_values.length < 5"
                  class="p-4 bg-gray-50 border border-gray-200 rounded-xl flex items-center gap-3"
                >
                  <i class="pi pi-receipt text-gray-500"></i>
                  <span class="text-sm text-gray-500 font-medium">No dietary recall data</span>
                </div>

                <div
                  *ngIf="qa.question_values && qa.question_values.length >= 5"
                  class="flex flex-col gap-4"
                >
                  <!-- Header -->
                  <div
                    class="px-5 py-4 bg-gradient-to-r from-orange-100/90 to-orange-50/40 rounded-2xl border border-orange-300/60 flex items-center gap-3 shadow-sm"
                  >
                    <div
                      class="w-8 h-8 rounded-full bg-white/70 flex items-center justify-center text-orange-600 shadow-sm"
                    >
                      <i class="pi pi-list font-bold"></i>
                    </div>
                    <span class="text-base font-bold text-orange-800 tracking-wide"
                      >Daily Meal Plan</span
                    >
                  </div>

                  <!-- Cards Iterator -->
                  <div
                    *ngFor="let meal of parseDietaryRecall(qa.question_values)"
                    class="rounded-2xl border-[1.5px] transition-all duration-300 overflow-hidden"
                    [ngClass]="
                      meal.entries.length > 0
                        ? [
                            getMealColorTheme(meal.meal).border,
                            getMealColorTheme(meal.meal).borderHover,
                          ]
                        : 'border-gray-200 bg-gray-50/50'
                    "
                  >
                    <!-- Card Header -->
                    <div
                      class="p-4 flex items-center justify-between pointer-events-none"
                      [ngClass]="
                        meal.entries.length > 0
                          ? getMealColorTheme(meal.meal).gradient
                          : 'bg-transparent'
                      "
                    >
                      <div class="flex items-center gap-3.5 pl-1">
                        <div
                          class="w-10 h-10 rounded-xl flex items-center justify-center shadow-sm"
                          [ngClass]="
                            meal.entries.length > 0
                              ? getMealColorTheme(meal.meal).bg + ' border border-white/50'
                              : 'bg-white border border-gray-200'
                          "
                        >
                          <i
                            class="pi font-bold"
                            [ngClass]="[
                              getMealIcon(meal.meal),
                              meal.entries.length > 0
                                ? getMealColorTheme(meal.meal).text
                                : 'text-gray-400',
                            ]"
                            style="font-size: 1.15rem"
                          ></i>
                        </div>
                        <span
                          class="text-[16px] font-bold tracking-wide"
                          [ngClass]="
                            meal.entries.length > 0
                              ? getMealColorTheme(meal.meal).deepText
                              : 'text-gray-500'
                          "
                          >{{ meal.meal }}</span
                        >
                      </div>
                      <div
                        *ngIf="meal.entries.length === 0"
                        class="px-3 py-1.5 bg-gray-200/70 rounded-lg text-[10px] font-extrabold text-gray-500 uppercase tracking-widest mr-1 border border-gray-300/50"
                      >
                        Empty
                      </div>
                    </div>

                    <!-- Card Body -->
                    <div
                      *ngIf="meal.entries.length > 0"
                      class="p-4 bg-white border-t border-gray-100/50 flex flex-col gap-3 shadow-inner"
                    >
                      <div
                        *ngFor="let entry of meal.entries"
                        class="p-3.5 bg-white rounded-xl border border-gray-200 shadow-sm flex flex-col gap-2.5 relative hover:shadow-md transition-shadow"
                      >
                        <div
                          *ngIf="entry.time_range || (entry.start_time && entry.end_time)"
                          class="flex items-center gap-2"
                        >
                          <div
                            class="flex items-center gap-1.5 px-2.5 py-1 rounded-md"
                            [ngClass]="getMealColorTheme(meal.meal).bg"
                          >
                            <i
                              class="pi pi-clock text-[12px]"
                              [ngClass]="getMealColorTheme(meal.meal).text"
                            ></i>
                            <span
                              class="text-[13px] font-bold"
                              [ngClass]="getMealColorTheme(meal.meal).deepText"
                            >
                              {{ entry.time_range || entry.start_time + ' - ' + entry.end_time }}
                            </span>
                          </div>
                        </div>

                        <div *ngIf="entry.value" class="flex items-start gap-3 mt-1 pl-1">
                          <i class="pi pi-receipt text-[15px] text-gray-400 mt-[3px]"></i>
                          <span
                            class="text-[15px] font-medium text-gray-800 whitespace-pre-wrap leading-relaxed flex-1"
                            >{{ entry.value }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="meal.entries.length === 0"
                      class="p-4 bg-transparent border-t border-gray-100/50 flex items-center gap-2.5 pl-6"
                    >
                      <i class="pi pi-minus-circle text-[15px] text-gray-400"></i>
                      <span class="text-[14px] font-medium text-gray-500"
                        >No entry recorded for this meal</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <!-- Type 6: Progress Bar -->
              <div
                *ngSwitchCase="QuestionType.Progress_Bar"
                class="mt-4 bg-gray-50 p-6 rounded-3xl border border-gray-100"
              >
                <div class="flex items-end justify-between mb-3">
                  <div class="flex flex-col">
                    <span
                      class="text-xs font-extrabold text-gray-400 uppercase tracking-widest mb-1"
                      >Assessed Value</span
                    >
                    <span class="text-3xl font-black text-blue-600"
                      >{{ qa.question_values || '0'
                      }}<span class="text-xl text-gray-400 font-bold ml-1">/ 100</span></span
                    >
                  </div>
                </div>
                <div
                  class="w-full bg-white border border-gray-200 p-1 rounded-full shadow-inner h-6"
                >
                  <div
                    class="bg-gradient-to-r from-blue-400 to-blue-600 h-full rounded-full transition-all duration-1000 shadow-sm relative overflow-hidden flex items-center justify-end px-2"
                    [style.width.%]="parseNumber(qa.question_values)"
                  >
                    <div
                      class="w-full h-full absolute inset-0 opacity-20 bg-[linear-gradient(45deg,rgba(255,255,255,.15)25%,transparent_25%,transparent_50%,rgba(255,255,255,.15)_50%,rgba(255,255,255,.15)_75%,transparent_75%,transparent)] bg-[length:1rem_1rem]"
                    ></div>
                  </div>
                </div>
              </div>

              <!-- Default Text / Number / Date / Unmatched types -->
              <div *ngSwitchDefault class="mt-3">
                <div
                  *ngIf="qa.question_values && qa.question_type !== QuestionType.File_Upload"
                  class="bg-blue-50/40 p-5 rounded-2xl border border-blue-100/50 text-[15.5px] text-gray-800 font-medium break-words whitespace-pre-wrap leading-relaxed shadow-sm"
                >
                  {{ qa.question_values }}
                </div>
                <div
                  *ngIf="
                    !qa.question_values &&
                    !qa.report_url &&
                    qa.question_type !== QuestionType.File_Upload
                  "
                  class="inline-flex items-center gap-2 bg-gray-50 px-5 py-3 rounded-xl border border-gray-100 text-sm font-semibold text-gray-400"
                >
                  <i class="pi pi-info-circle"></i> Answer not provided
                </div>
              </div>
            </div>

            <!-- Body Images Preview (If any) -->
            <div
              *ngIf="qa.front_profile_img || qa.left_profile_img || qa.right_profile_img"
              class="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8 p-6 bg-gray-50 rounded-3xl border border-gray-100 shadow-sm relative"
            >
              <div
                class="absolute -top-3 left-6 text-[10px] font-extrabold text-gray-500 uppercase tracking-widest bg-white px-3 py-1 rounded-full border border-gray-200 shadow-sm"
              >
                <i class="pi pi-camera mr-1 text-[9px]"></i> Attached Media
              </div>

              <div *ngIf="qa.front_profile_img" class="flex flex-col gap-3 relative mt-2 sm:mt-0">
                <span
                  class="text-[11px] font-extrabold text-blue-700 uppercase tracking-wider text-center bg-blue-100/50 py-1.5 rounded-xl border border-blue-100 mx-2 z-10 relative shadow-sm"
                  >Front View</span
                >
                <div
                  class="aspect-[3/4] rounded-2xl overflow-hidden border-4 border-white bg-gray-200 shadow-md group/img relative"
                >
                  <p-image
                    [src]="qa.front_profile_img"
                    alt="Front Profile"
                    [preview]="true"
                    imageClass="w-full h-full object-cover"
                  ></p-image>
                </div>
                <div class="flex items-center justify-center gap-2 mt-1">
                  <a [href]="qa.front_profile_img" target="_blank" class="no-underline"
                    ><p-button
                      icon="pi pi-external-link"
                      size="small"
                      severity="secondary"
                      [rounded]="true"
                    ></p-button
                  ></a>
                  <a [href]="qa.front_profile_img" download class="no-underline"
                    ><p-button icon="pi pi-download" size="small" [rounded]="true"></p-button
                  ></a>
                </div>
              </div>

              <div *ngIf="qa.left_profile_img" class="flex flex-col gap-3 relative mt-6 sm:mt-0">
                <span
                  class="text-[11px] font-extrabold text-blue-700 uppercase tracking-wider text-center bg-blue-100/50 py-1.5 rounded-xl border border-blue-100 mx-2 z-10 relative shadow-sm"
                  >Left Profile</span
                >
                <div
                  class="aspect-[3/4] rounded-2xl overflow-hidden border-4 border-white bg-gray-200 shadow-md group/img relative"
                >
                  <p-image
                    [src]="qa.left_profile_img"
                    alt="Left Profile"
                    [preview]="true"
                    imageClass="w-full h-full object-cover"
                  ></p-image>
                </div>
                <div class="flex items-center justify-center gap-2 mt-1">
                  <a [href]="qa.left_profile_img" target="_blank" class="no-underline"
                    ><p-button
                      icon="pi pi-external-link"
                      size="small"
                      severity="secondary"
                      [rounded]="true"
                    ></p-button
                  ></a>
                  <a [href]="qa.left_profile_img" download class="no-underline"
                    ><p-button icon="pi pi-download" size="small" [rounded]="true"></p-button
                  ></a>
                </div>
              </div>

              <div *ngIf="qa.right_profile_img" class="flex flex-col gap-3 relative mt-6 sm:mt-0">
                <span
                  class="text-[11px] font-extrabold text-blue-700 uppercase tracking-wider text-center bg-blue-100/50 py-1.5 rounded-xl border border-blue-100 mx-2 z-10 relative shadow-sm"
                  >Right Profile</span
                >
                <div
                  class="aspect-[3/4] rounded-2xl overflow-hidden border-4 border-white bg-gray-200 shadow-md group/img relative"
                >
                  <p-image
                    [src]="qa.right_profile_img"
                    alt="Right Profile"
                    [preview]="true"
                    imageClass="w-full h-full object-cover"
                  ></p-image>
                </div>
                <div class="flex items-center justify-center gap-2 mt-1">
                  <a [href]="qa.right_profile_img" target="_blank" class="no-underline"
                    ><p-button
                      icon="pi pi-external-link"
                      size="small"
                      severity="secondary"
                      [rounded]="true"
                    ></p-button
                  ></a>
                  <a [href]="qa.right_profile_img" download class="no-underline"
                    ><p-button icon="pi pi-download" size="small" [rounded]="true"></p-button
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sticky bottom-0 w-full px-4 pb-4 pt-2 bg-card/40 backdrop-blur  z-50">
    <div class="max-w-lg mx-auto flex flex-col gap-3">
      <!-- Diet Button -->
      <button
        (click)="goToDiet()"
        class="w-full py-4 rounded-full bg-green-300 hover:bg-green-400 text-white text-lg font-semibold shadow-lg transition-all"
      >
        View Diet Summary
      </button>

      <!-- Score Button -->
      <button
        (click)="goToScore()"
        class="w-full py-4 rounded-full bg-orange-300 hover:bg-orange-400 text-white text-lg font-semibold shadow-lg transition-all"
      >
        View Pre Assessment Score
      </button>
    </div>
  </div>
</div>
